import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { Helmet } from "react-helmet";
import { OnboardingSteps } from './OnboardingSteps';

export class Master extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      services: [],
      resources: []
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name,
      activeFaq: 0,
    }));
    if (isAuthenticated) {
      this.populateCompaniesData();
    }
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (data.length > 0) {
      const response1 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/services`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data1 = await response1.json();
      this.setState(prevState => ({...prevState, services: data1}));

      const response2 = await fetch(`{{mainApiUrl}}api/companies/${data[0].id}/resources`, {
        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
      });
      const data2 = await response2.json();
      this.setState(prevState => ({...prevState, resources: data2.filter(d => d.assigned)}));
    }
  }

  toggleFaq = (index) => {
    this.setState(prev => ({ activeFaq: prev.activeFaq === index ? -1 : index }));
  };

  render() {
    const faqs = [
      { q: "❓ Это действительно бесплатно для меня как для частного мастера?", a: "Да. Никакой абонентской платы, процентов с броней. Оплата только за SMS и эквайринг (если подключите онлайн-оплату). Бесплатно навсегда." },
      { q: "❓ Как мои клиенты смогут записаться?", a: "Мы создадим для вас персональную страницу онлайн-записи и сгенерируем QR-код. Разместите его в Instagram, WhatsApp, на визитках — клиенты будут записываться в 2 клика 24/7. Вы также можете добавлять брони вручную по телефону." },
      { q: "❓ Нужно ли клиентам устанавливать приложение?", a: "Нет, достаточно браузера. Но для удобства есть нативные приложения для iOS и Android." },
      { q: "❓ Что делать, если клиент не пришёл?", a: "Система автоматически отправляет напоминание о визите за день и за час. Это снижает неявки на 70%." },
      { q: "❓ Могу ли я блокировать время для личных дел?", a: "Да. Если вы запишетесь к врачу или в спортзал через наш сервис, это время автоматически заблокируется в вашем рабочем календаре. Никаких двойных бронирований." }
    ];

    return (
      <div class="fa-container">
        <Helmet>
          <title>Онлайн-запись для частных мастеров | Бесплатная CRM — Planna</title>
          <meta name="description" content="Принимайте клиентов онлайн 24/7. QR-код, напоминания, единый календарь (личное + рабочее). Для массажистов, репетиторов, бровистов, парикмахеров. Бесплатно навсегда." />
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"/>
          <link href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,400;14..32,500;14..32,600;14..32,700&family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap" rel="stylesheet"/>
          <script src="{{mainApiUrl}}landing.js"></script>
        </Helmet>

        {/* Hero */}
        <section className="hero">
          <div className="container fade-up">
            <div className="hero-badge">💆‍♂️ Для частных мастеров | Бесплатно навсегда</div>
            <h1>Онлайн-запись <span className="highlight">для частных мастеров</span></h1>
            <p className="hero-description">Замените тетрадку и звонки. Клиенты записываются 24/7 через QR-код и ссылку. Автоматические напоминания, единый календарь (личное + рабочее), аналитика. Всё бесплатно.</p>
            <div className="hero-buttons" style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              {!this.state.isAuthenticated ? <a href="/authentication/register" className="btn-filled">Зарегистрироваться <i className="fas fa-arrow-right"></i></a> : <></>}
              <a href="/configcompany" className={this.state.isAuthenticated ? "btn-filled" : "btn-outline"}>Подключиться бесплатно <i className="fas fa-play"></i></a>
            </div>
          </div>
        </section>

        {/* Преимущества */}
        <section>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Всё для вашего удобства</h2>
              <p className="section-subtitle">Принимайте клиентов без лишних хлопот</p>
            </div>
            <div className="grid-3 fade-up">
              <div className="benefit-card"><i className="fas fa-calendar-check benefit-icon"></i><h3>Онлайн-запись 24/7</h3><p>Клиенты сами выбирают удобное время. Никаких звонков ночью.</p></div>
              <div className="benefit-card"><i className="fas fa-phone-alt benefit-icon"></i><h3>Запись по телефону</h3><p>Вы вносите бронь вручную за 10 секунд. Всё в одном календаре.</p></div>
              <div className="benefit-card"><i className="fas fa-users benefit-icon"></i><h3>Единый календарь</h3><p>Личные дела и работа – в одном месте. Автоматическая блокировка занятого времени.</p></div>
              <div className="benefit-card"><i className="fas fa-bell benefit-icon"></i><h3>Автоматические напоминания</h3><p>SMS, Telegram, push – клиенты не забывают, неявки снижаются на 70%.</p></div>
              <div className="benefit-card"><i className="fas fa-qrcode benefit-icon"></i><h3>QR-код для соцсетей</h3><p>Разместите в Instagram или WhatsApp – запись в один клик.</p></div>
              <div className="benefit-card"><i className="fas fa-chart-line benefit-icon"></i><h3>Аналитика</h3><p>Средний чек, количество клиентов, загрузка – полный контроль.</p></div>
            </div>
          </div>
        </section>

        {/* Скриншоты (замените src) */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="fade-up" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Как это работает</h2>
              <p className="section-subtitle">Просто, быстро, удобно</p>
            </div>
            <div className="grid-2 fade-up" style={{ gap: '2.5rem' }}>
              <div className="screenshot-placeholder">
                <img src="
https://placehold.co/600x400/EEF2FF/3B82F6?text=Календарь+мастера
" alt="Календарь мастера" />
                <div className="mockup-label">📅 Ваше расписание всегда под рукой</div>
              </div>
              <div className="screenshot-placeholder">
                <img src="
https://placehold.co/600x400/EEF2FF/3B82F6?text=QR-код+для+клиентов
" alt="QR-код" />
                <div className="mockup-label">📱 QR-код – клиенты записываются сами</div>
              </div>
              <div className="screenshot-placeholder">
                <img src="
https://placehold.co/600x400/EEF2FF/3B82F6?text=Напоминание+клиенту
" alt="Напоминание" />
                <div className="mockup-label">🔔 Напоминание о визите</div>
              </div>
              <div className="screenshot-placeholder">
                <img src="
https://placehold.co/600x400/EEF2FF/3B82F6?text=Единый+календарь
" alt="Единый календарь" />
                <div className="mockup-label">🔄 Личные и рабочие дела – вместе</div>
              </div>
            </div>
          </div>
        </section>

        {/* Умные функции */}
        <section>
          <div className="container">
            {/* Подписка на освободившиеся слоты */}
            <div className="smart-block fade-up" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem', marginTop: 0 }}>
              <div style={{ flex: 1 }}>
                <i className="fas fa-bell" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Не упускайте клиентов</h3>
                <p style={{ margin: '1rem 0', color: '#374151' }}>Если все слоты заняты, клиент может <strong>подписаться на освобождение времени</strong>. Как только кто-то отменит запись – система мгновенно оповестит клиента. Он забронирует первым.</p>
                <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Автоматические уведомления</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Больше никаких потерянных клиентов</li></ul>
              </div>
              <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="
https://placehold.co/500x300/F9FAFB/32bea6?text=Подписка+на+слот
" alt="Подписка" /><div className="mockup-label">🔔 Клиент подписывается – вы получаете клиента</div></div></div>
            </div>

            {/* Календарь месяца с загрузкой */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-chart-line" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Клиент видит вашу загрузку</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Клиент выбирает день на календаре с цветовой индикацией: зелёные дни – свободно, красные – пик. Легко выбрать спокойное время для визита.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Равномерная нагрузка</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Клиенты ценят выбор</li></ul>
                </div>
                <div style={{ flex: 0.9 }}><div className="screenshot-placeholder"><img src="
https://placehold.co/450x280/F9FAFB/32bea6?text=Календарь+загрузки
" alt="Календарь загрузки" /><div className="mockup-label">📅 Зелёный – свободно, красный – пик</div></div></div>
              </div>
            </div>

            {/* Единый календарь (личное + рабочее) */}
            <div className="smart-block fade-up" style={{ background: '#FFFFFF', border: '1px solid rgba(50,190,166,0.3)', marginTop: '2rem' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem', flexDirection: 'row-reverse' }}>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-calendar-alt" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Единое пространство времени</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Вы записались к стоматологу через наш сервис? Это время автоматически блокируется в вашем рабочем календаре. Никаких конфликтов. Всё в одном месте.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Рабочие и личные дела – вместе</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Никаких двойных бронирований</li></ul>
                </div>
                <div style={{ flex: 0.9 }}><div className="screenshot-placeholder"><img src="
https://placehold.co/450x280/F9FAFB/32bea6?text=Единый+календарь
" alt="Единый календарь" /><div className="mockup-label">🔄 Синхронизация личного и рабочего</div></div></div>
              </div>
            </div>

            {/* Два календаря при бронировании */}
            <div className="smart-block fade-up" style={{ background: 'linear-gradient(110deg, rgba(50,190,166,0.05) 0%, #FFFFFF 100%)', marginTop: '2rem' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem' }}>
                <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="
https://placehold.co/450x280/F9FAFB/32bea6?text=Два+календаря
" alt="Два календаря" /><div className="mockup-label">📅 Два календаря – один выбор</div></div></div>
                <div style={{ flex: '1.2' }}>
                  <i className="fas fa-eye" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                  <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>При бронировании – два календаря рядом</h3>
                  <p style={{ margin: '1rem 0', color: '#374151' }}>Клиент видит свои личные события (Google/Apple) и ваши свободные слоты. Выбирает только время, которое подходит обоим. <strong>Никакой синхронизации</strong> – только чтение.</p>
                  <ul style={{ listStyle: 'none' }}><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Без конфликтов с планами клиента</li><li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> Удобный выбор времени</li></ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Типы мастеров */}
        <section style={{ background: '#FEF9F0' }}>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Подходит для любых специалистов</h2>
            <div className="stats-grid" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1.5rem', marginTop: '2rem' }}>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '150px' }}><i className="fas fa-hand-sparkles"></i><h3>Массажист</h3><p>Онлайн-запись, напоминания</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '150px' }}><i className="fas fa-chalkboard-teacher"></i><h3>Репетитор</h3><p>Расписание уроков</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '150px' }}><i className="fas fa-cut"></i><h3>Парикмахер / бровист</h3><p>Запись на процедуры</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '150px' }}><i className="fas fa-dumbbell"></i><h3>Фитнес-тренер</h3><p>Индивидуальные тренировки</p></div>
              <div className="benefit-card" style={{ background: 'white', textAlign: 'center', minWidth: '150px' }}><i className="fas fa-brain"></i><h3>Психолог</h3><p>Конфиденциальная запись</p></div>
            </div>
          </div>
        </section>

        {/* Мобильные приложения */}
        <section style={{ background: '#F9FAFB' }}>
          <div className="container">
            <div className="smart-block fade-up" style={{ background: 'white', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '2rem' }}>
              <div style={{ flex: 1 }}><div className="screenshot-placeholder"><img src="{{mainApiUrl}}mobile1.png" alt="Мобильное приложение" /><div className="mockup-label">📱 Управляйте расписанием со смартфона</div></div></div>
              <div style={{ flex: '1.2' }}>
                <i className="fas fa-mobile-alt" style={{ fontSize: '2.5rem', color: '#32bea6', marginBottom: '1rem', display: 'inline-block' }}></i>
                <h3 style={{ fontSize: '1.8rem', fontWeight: '700' }}>Мобильные приложения для всех</h3>
                <p>Ваши клиенты и вы можете пользоваться сервисом через нативные приложения для iOS и Android.</p>
                <ul style={{ listStyle: 'none', marginTop: '1rem' }}>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для мастера:</strong> управление расписанием, уведомления, аналитика</li>
                  <li><i className="fas fa-check-circle" style={{ color: '#32bea6' }}></i> <strong>Для клиентов:</strong> запись в один клик, календарь, отзывы</li>
                </ul>
                <div className="app-badges" style={{ display: 'flex', justifyContent: 'flex-start', gap: '20px', margin: '20px 0 0 0' }}>
                  <a href="https://apps.apple.com/ru/app/id6773870898" target="_blank"><img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="App Store" style={{ height: '45px' }} /></a>
                  <a href="https://play.google.com/store/apps/details?id=com.planna.app" target="_blank"><img src="https://play.google.com/intl/en_us/badges/static/images/badges/ru_badge_web_generic.png" alt="Google Play" style={{ height: '45px' }} /></a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container fade-up" style={{ textAlign: 'center' }}>
            <h2 className="section-title">Как это работает за 5 минут</h2>
            <OnboardingSteps
              isRegistered={this.state.isAuthenticated}
              hasCompany={this.state.companies.length > 0}
              hasServices={this.state.services.length > 0}
              hasResources={this.state.resources.length > 0}
              servicesCount={this.state.services.length}
              resourcesCount={this.state.resources.length}
              companyId={this.state.services.length > 0 ? this.state.companies[0].id : 0}
            />
          </div>
        </section>

        {/* FAQ */}
        <section>
          <div className="container fade-up">
            <h2 className="section-title" style={{ textAlign: 'center' }}>Частые вопросы</h2>
            <div style={{ maxWidth: '800px', margin: '2rem auto' }}>
              {faqs.map((faq, idx) => (
                <div key={idx} className={`faq-item ${this.state.activeFaq === idx ? 'active' : ''}`}>
                  <div className="faq-question" onClick={() => this.toggleFaq(idx)}>
                    {faq.q} <i className="fas fa-chevron-down"></i>
                  </div>
                  <div className="faq-answer">{faq.a}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section style={{ background: 'linear-gradient(115deg, #1F2937 0%, #32bea6 100%)', color: 'white' }}>
          <div className="container fade-up" style={{ textAlign: 'center', padding: '80px 0' }}>
            <h2 style={{ fontSize: '2.2rem', fontWeight: '800' }}>Начните принимать онлайн-запись уже сегодня</h2>
            <p style={{ fontSize: '1.1rem', margin: '1rem auto 2rem', maxWidth: '600px', opacity: 0.9 }}>Перестаньте терять клиентов из-за занятого телефона и путаницы в расписании.</p>
            <a href="/configcompany" className="btn-filled" style={{ background: 'white', color: '#1F2937', boxShadow: 'none' }}>Подключиться бесплатно <i className="fas fa-arrow-right"></i></a>
            <p style={{ marginTop: '2rem', fontSize: '0.9rem' }}>Настройка за 5 минут. QR-код, напоминания, аналитика — 0₽</p>
          </div>
        </section>
      </div>
    );
  }
}
